import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import {
  ApiResponse,
  CalibrationLocation,
  CalibrationMeasurement,
  InProcessCalibration,
  PeriodicCalibration,
  PeriodicCalibrationDetail,
} from '../interfaces';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class CalibrationService {
  private readonly _api = inject(ApiService);
  private readonly _apiPath = 'calibrations';

  getPeriodicCalibrations(location: string) {
    const params: { [key: string]: string } = {};
    if (location && location !== '') {
      params['location'] = location;
    }
    return this._api.get<PeriodicCalibration[]>(`${this._apiPath}/periodic`, {
      params,
    });
  }

  getPeriodicCalibrationByID(periodicCalibrationId: string) {
    console.info(periodicCalibrationId);
    return of({
      data: [
        {
          periodicCalibrationId: '1',
          inspectionEquipmentID: 6309,
          inspectionEquipmentNr: 'CZ - 36004628/1',
          location: 'CZ-Plant Okrisky',
          historizedDecision: 'Verwendbar',
          historyId: 1,
          inspectionDate: '2025-01-14T06:51:43.1833333',
          eventName: 'Dummy',
          createdOn: '2025-01-14T06:51:43.1833333',
          inspectionEquipmentType: 'Red rabbit / Green rabbit',
          characteristicName: 'Dummy',
          characteristicShouldValue: '1.0',
          characteristicLowerLimit: '1.0',
          characteristicUpperLimit: '1.0',
          characteristicMeasureUnit: 'mm',
        },
      ],
    });
  }

  getPeriodicCalibrationDetails(periodicCalibrationId: string) {
    return this._api.get<PeriodicCalibrationDetail[]>(
      `${this._apiPath}/${periodicCalibrationId}`,
    );
  }

  getInProcessCalibrations(
    equipmentId?: string,
    from?: Date,
    to?: Date,
    companyId?: string,
  ) {
    const params: { [key: string]: string } = {};
    if (equipmentId) {
      params['equipmentId'] = equipmentId;
    }
    if (from) {
      params['from'] = from.toISOString();
    }
    if (to) {
      params['to'] = to.toISOString();
    }

    if (companyId) {
      params['accountingUnit'] = companyId;
    }
    return this._api.get<InProcessCalibration[]>(
      `${this._apiPath}/in-process`,
      {
        params,
      },
    );
  }

  getMeasurementsData(
    orderId: number,
    articleId: string,
    batchId: string,
    orderPositionId: string,
  ) {
    const params: { [key: string]: string } = {};
    if (orderId) {
      params['orderId'] = orderId.toString();
    }
    if (articleId) {
      params['articleId'] = articleId;
    }
    if (batchId) {
      params['batchId'] = batchId;
    }

    if (orderPositionId) {
      params['orderPositionId'] = orderPositionId;
    }
    return this._api.get<CalibrationMeasurement[]>(
      `${this._apiPath}/in-process/measurements`,
      {
        params,
      },
    );
  }

  getInProcessCalibrationByID(id: string) {
    console.info(id);
    return of({
      data: {
        inspectionEquipmentId: '40806709',
        articleId: '40806709',
        batchId: '255670',
        inProcessCalibrationId: 'CAE2C2DA-C4E7-4D70-84E5-21D1AFB5A0CC',
        babtecProductionOrderId: '528783-FA-03-01-01',
        orderId: 1108452,
        testingSiteId: 621,
        testingSiteName: 'PRO-CZ-ASSEMBLY',
        orderPositionId: 1705238,
        workstepDecisionId: 1,
        workstepDecision: 'Accepted',
        workstepDecisionDate: '2022-12-21T10:36:56.640',
        orderPositionManualDecision: 1,
        orderPositionSystemDecision: 1,
        orderPositionCalibrationDate: '2022-12-01T08:44:02.233',
        characteristicId: 690809,
        characteristicName: 'Funkční zkouška senzorů [Němčina]',
        characteristicType: 0,
        characteristicDecision: 1,
        inspectionEquipmentType: 'Red rabbit / Green rabbit',
        orderCharacteristicId: 6643482,
        stichNr: 1,
        measuredValueNr: 1,
        measuredValue: 1.0,
        measureDate: '2022-12-01T08:44:02.233',
        createdOn: '2025-01-14T09:09:48.8533333',
        workstepDescription: 'Workstep description',
      },
    });
  }

  getCalibrationLocations(): Observable<ApiResponse<CalibrationLocation[]>> {
    return this._api.get<CalibrationLocation[]>(`${this._apiPath}/locations`);
  }

  getAccountingUnits(): Observable<ApiResponse<CalibrationLocation[]>> {
    return this._api.get<CalibrationLocation[]>(
      `${this._apiPath}/accounting-units`,
    );
  }
}
